import API from "./API";

class Ticket {
  static async create(data) {
    return await API.post("/merchant/tickets/", data, { needAuth: true });
  }

  static async get(id) {
    return await API.get(`/merchant/tickets/${id}`, { needAuth: true });
  }

  static async setStatus(id, data) {
    return await API.put(`/merchant/tickets/${id}/status`, data, {
      needAuth: true
    });
  }
}

export default Ticket;
